// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description[data-v-1633adf4]{max-width:838px}.p-relative[data-v-1633adf4]{position:relative}.edit-btn[data-v-1633adf4]{position:absolute;right:-8px;top:-48px;z-index:10}.load-page[data-v-1633adf4]{border-radius:8px;font-size:14px;font-weight:700;line-height:16px;margin:0 auto;padding:18px;text-transform:uppercase}.load-page .icon[data-v-1633adf4]{font-size:20px;margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
